



















































import Vue from 'vue'

export default Vue.extend({
  props: {
    /**
     * マスクされる範囲の上端
     */
    top: {
      type: Number,
      default: 0
    },

    /**
     * マスクされる範囲の左端
     */
    left: {
      type: Number,
      default: 0
    },

    /**
     * マスクされる範囲の右端
     */
    right: {
      type: Number,
      default: 0
    },

    /**
     * マスクされる範囲の下端
     */
    bottom: {
      type: Number,
      default: 0
    },

    /**
     * 斜線の色
     */
    color: {
      type: String,
      default: 'red'
    },

    /**
     * 斜線の太さ
     */
    width: {
      type: Number,
      default: 2
    },

    /**
     * 斜線同士の間隔
     * 小さいほど狭くなり、大きいほど広くなる
     */
    interval: {
      type: Number,
      default: 16
    }
  },

  computed: {
    /**
     * マスクで使う斜線.
     * 参考: https://stackoverflow.com/questions/13069446/simple-fill-pattern-in-svg-diagonal-hatching
     */
    d(): string {
      return `
      M -1 1 l ${this.interval / 2} -${this.interval / 2}
      M 0 ${this.interval} l ${this.interval} -${this.interval}
      M ${this.interval - 1} ${this.interval + 1} l ${this.interval / 2} -${
        this.interval / 2
      }
      `
    }
  }
})
